import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import clsx from "clsx";
import { Field, FieldProps } from "formik";
import { ChangeEventHandler, KeyboardEventHandler } from "react";

import { FormikErrorMessage } from "./FormikErrorMessage";
import { BasicFormikInputProps } from "./type";

interface TextAreaAutoResizeInputFieldProps extends BasicFormikInputProps {
  className?: string;
  outlineColor?: string;
  validate?: (value: string) => undefined | string | Promise<any>;
  rowsMin?: number;
  rowsMax?: number;
  showErrorMessage?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
  autoFocus?: boolean;
}

export const TextAreaAutoResizeInputField: React.FC<TextAreaAutoResizeInputFieldProps> =
  (props) => {
    const {
      name,
      style,
      className = "border-gray-200",
      outlineColor,
      validate,
      rowsMin,
      rowsMax,
      showErrorMessage = true,
      disabled = false,
      placeholder,
      onChange,
      onKeyDown,
      autoFocus = false,
    } = props;

    return (
      <Field name={name} validate={validate}>
        {({ field }: FieldProps) => {
          const { onChange: defaultOnChange, ...otherField } = field;

          return (
            <div
              className={clsx(
                "relative rounded-md border focus-within:border-primary",
                className,
              )}
            >
              {showErrorMessage && <FormikErrorMessage name={name} />}
              <TextareaAutosize
                autoFocus={autoFocus}
                className="resize-none outline-none border-none rounded-lg w-full p-2 text-base"
                rowsMax={rowsMax ?? 10}
                rowsMin={rowsMin ?? 1}
                name={name}
                placeholder={placeholder}
                disabled={disabled}
                onChange={onChange ? onChange : defaultOnChange}
                onKeyDown={onKeyDown}
                {...otherField}
              />
            </div>
          );
        }}
      </Field>
    );
  };
